import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import EditData from "../../components/editUserData/editData";
import { IUserReport } from "../../services/types/users.types";
import MainContentLayout from "../../components/mainContentLayout/mainContentLayout";
import { Category } from "../../types/types";

function EditUserDataPage() {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get user and initialCategory from location state
  const user = location.state?.user as IUserReport | undefined;
  const initialCategory = location.state?.initialCategory as string | undefined;
  const fromAppointments = location.state?.fromAppointments as boolean | undefined;

  const handleClose = () => {
    if (fromAppointments) {
      navigate('/appointments');
    } else {
      navigate(-1);
    }
  };

  if (!user) {
    handleClose();
    return null;
  }

  return (
    <MainContentLayout
      activeCategory={Category.Main}
      changeCategory={() => {}}
    >
      <EditData 
        user={user} 
        onClose={handleClose} 
        skipApiCallsOnClose={true}
        initialCategory={initialCategory}
        fromAppointments={fromAppointments}
      />
    </MainContentLayout>
  );
}

export default EditUserDataPage;

